/* cookie-helper.js — v2.6.6
   jquery-cookie 1.4.1'in yerine gecer. O eklenti 2014'te terk edildi ve
   yerini js-cookie'ye birakti. Tema yalnizca $.cookie(name) okuma ve
   $.cookie(name, value, {expires: n}) yazma bicimlerini kullaniyordu.
   Bu dosya ayni imzayi bagimliliksiz olarak saglar; jQuery varsa $.cookie
   ve $.removeCookie geriye donuk uyum icin yine tanimlanir. */
(function (window) {
  'use strict';

  function readAll() {
    var out = {};
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var idx = parts[i].indexOf('=');
      if (idx < 0) continue;
      var k = parts[i].slice(0, idx);
      var v = parts[i].slice(idx + 1);
      try { k = decodeURIComponent(k); } catch (e) {}
      try { v = decodeURIComponent(v); } catch (e) {}
      out[k] = v;
    }
    return out;
  }

  function cookie(name, value, options) {
    // okuma
    if (arguments.length === 1 || value === undefined) {
      if (name === undefined) return readAll();
      var all = readAll();
      return Object.prototype.hasOwnProperty.call(all, name) ? all[name] : undefined;
    }
    // yazma
    options = options || {};
    var expires = options.expires;
    if (typeof expires === 'number') {
      var d = new Date();
      d.setTime(d.getTime() + expires * 864e5); // gun
      expires = d;
    }
    var str = encodeURIComponent(name) + '=' + encodeURIComponent(String(value));
    if (expires instanceof Date) str += '; expires=' + expires.toUTCString();
    str += '; path=' + (options.path || '/');
    if (options.domain) str += '; domain=' + options.domain;
    str += '; SameSite=' + (options.sameSite || 'Lax');
    if (location.protocol === 'https:') str += '; Secure';
    document.cookie = str;
    return str;
  }

  function removeCookie(name, options) {
    if (cookie(name) === undefined) return false;
    cookie(name, '', Object.assign({}, options, { expires: -1 }));
    return cookie(name) === undefined;
  }

  window.getCookie = window.getCookie || function (n) { var v = cookie(n); return v === undefined ? '' : v; };
  window.setCookie = window.setCookie || function (n, v, days) { cookie(n, v, { expires: days }); };
  window.themeCookie = { get: cookie, set: cookie, remove: removeCookie };

  if (window.jQuery) {
    window.jQuery.cookie = cookie;
    window.jQuery.removeCookie = removeCookie;
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.jQuery && !window.jQuery.cookie) {
        window.jQuery.cookie = cookie;
        window.jQuery.removeCookie = removeCookie;
      }
    });
  }
})(window);
